export const Types = {
    SAVE_LIST_PACKAGE: 'SAVE_LIST_PACKAGE',
    SAVE_LIST_ACCUMULATION: 'SAVE_LIST_ACCUMULATION',
    SAVE_LIST_TRANSACTION: 'SAVE_LIST_TRANSACTION'
}
